import { supabase } from "./supaBase";
export const getLessons = async () => {
    const { data: lesson, error } = await supabase
        .from('lesson')
        .select('*');
    return lesson;
};
export const saveStats = async (user_id, lesson_id, wpm, total_time_sec, accuracy, real_accuracy, detail) => {
    const { data, error } = await supabase
        .from('stats')
        .insert([
        { user_id: user_id, lesson_id: lesson_id, wpm: wpm, total_time_sec: total_time_sec, accuracy: accuracy, real_accuracy: real_accuracy, detail: JSON.stringify(detail) },
    ]);
};
export const getStats = async (lesson_id) => {
    const { data, error } = await supabase
        .from('stats')
        .select('*').eq('lesson_id', lesson_id).order('id', { ascending: false }).range(0, 9);
    return data;
};
export const addNew = async (user_id, title, content) => {
    return await supabase
        .from('lesson')
        .insert([
        { user_id: user_id, title: title, content: content },
    ]);
};
